export const leaderBoardsKeys = {
  all: ['leaderboards'] as const,
  global: () => [...leaderBoardsKeys.all, 'global'] as const,
  lastFinished: () => [...leaderBoardsKeys.all, 'last-finished'] as const,
  current: () => [...leaderBoardsKeys.all, 'current'] as const,
};
